import { createReducer, on } from '@ngrx/store';
import * as DebugActions from './debug.actions';

export const debugFeatureKey = 'debug';

export interface DebugState {
  enabled: boolean;
}

export const initialDebugState: DebugState = {
  enabled: false,
};

export const debugReducer = createReducer(
  initialDebugState,

  on(
    DebugActions.setDebug,
    (state, { enabled }): DebugState => ({
      ...state,
      enabled,
    }),
  ),
);
